module.exports = __webpack_public_path__ + "img/kinesitherapeute-h.55d24892.jpg";